export const DEFAULT_LANGUAGE = "ar";
export const DEFAULT_USER_IMAGE = "/images/users/default-user.png";
export const API_URL = process.env.REACT_APP_API_URL;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
export const GENERAL_TOKEN = process.env.REACT_APP_GENERAL_TOKEN;

const test = {
  DEFAULT_LANGUAGE,
  DEFAULT_USER_IMAGE,
  API_URL,
  STORAGE_URL,
  GENERAL_TOKEN,
}
export default test;
